<!--
 @description 灰度配置历史
 @author xiehan
 @date 2019/08/21
-->
<template>
  <div class="grayConfigHis__content">
    <div class="grayConfigHis__form">
      <el-form ref="searchForm" :model="searchForm" :inline="true">
        <el-form-item :label="$t('grayConfig.routeVersionName')">
          <el-input v-model="searchForm.routeVersionName"></el-input>
        </el-form-item>
        <el-form-item :label="$t('grayConfig.tagName')">
          <el-input v-model="searchForm.tagName"></el-input>
        </el-form-item>
        <el-form-item :label="$t('grayConfig.routeVersionGroup')">
          <g-select v-model="searchForm.routeVersionGroup" :list="select_group" :defaultAll="true"></g-select>
        </el-form-item>
        <el-form-item :label="$t('grayConfig.tagStatus')">
          <g-select v-model="searchForm.tagStatus" :list="select_status" :defaultAll="true"></g-select>
        </el-form-item>
        <el-form-item :label="$t('common.handle')">
          <g-select v-model="searchForm.operateType" :list="select_operate" :defaultAll="true"></g-select>
        </el-form-item>
        <el-form-item :label="$t('grayConfig.operateTime')" input-width="auto">
          <el-form-item prop="operateStartTime">
            <el-date-picker value-format="timestamp" style="width: 180px;" v-model="searchForm.operateStartTime" type="datetime">
            </el-date-picker>
          </el-form-item>
          <span v-text="$t('common.to')"></span>
          <el-form-item prop="operateEndTime" style="margin-left: 10px">
            <el-date-picker value-format="timestamp" style="width: 180px;" v-model="searchForm.operateEndTime" type="datetime">
            </el-date-picker>
          </el-form-item>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search" v-g-rac="gRac('grayConfigHis@search')">{{ $t('common.search') }}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table-extend
      :data="tData" 
      :head="tHead" 
      :currentChange="tCurrentChange" 
      :sizeChange="tSizeChange" 
      border>
    </el-table-extend>
  </div>
</template>

<script>
  import table from '@/components/mixins/table'
  import dic from '@/components/mixins/dic'
  import grayConfigBiz from '@/logic/continuousDelivery/grayConfigBiz'
  import { extend } from '@/utils/tool'
  import TimeFormat from '@/utils/timeFormat'
  import rac from '@/plugins/rac-mixin.js'
  export default {
    mixins: [rac, dic, table],
    data () {
      return {
        searchForm: {
          routeVersionName: '',
          tagName: '',
          routeVersionGroup: '',
          tagStatus: '',
          operateType: '',
          operateStartTime: new Date().getTime() - 86400000,
          operateEndTime: ''
        },
        select_group: {},
        select_status: {},
        select_operate: {}
      }
    },
    methods: {
      async preInitTable () {
        await Promise.all([
          this.dGetDictionaryByCode('groupType'),
          this.dGetDictionaryByCode('tag_status'),
          this.dGetDictionaryByCode('tag_operate_type')
        ])
        this.select_group = { ...this.dDictionary.groupType }
        this.select_status = { ...this.dDictionary.tag_status }
        this.select_operate = { ...this.dDictionary.tag_operate_type }
        this.initTable()
      },
      initTable () {
        this.tInitTable({
          lanKey: 'grayConfig.table',
          head: ['tagId', 'routeVersionName', 'routeVersionGroup', 'tagName', 'routeRuleName', 'routeStrategyName', 'tagStatusAfter', 'modifyTime', 'operateType'],
          requestFun: this.searchTable,
          headOpt: {
            routeVersionGroup: {
              formatter: 'Dictionary',
              formatterDic: this.select_group
            },
            tagStatusAfter: {
              formatter: 'Dictionary',
              formatterDic: this.select_status
            },
            operateType: {
              formatter: 'Dictionary',
              formatterDic: this.select_operate
            }
          }
        })
        this.searchTable()
      },
      search () {
        this.tResetPage()
        this.searchTable()
      },
      searchTable () {
        const reqData = extend(true, { ...this.tPageInfo }, this.searchForm)
        for (let i in reqData) {
          if (reqData[i] === '') {
            delete reqData[i]
          }
        }
        if (!reqData.operateEndTime) reqData.operateEndTime = new Date().getTime()
        grayConfigBiz.tagHisQuery(reqData).then((data) => {
          if (data && data.dataList) {
            data.dataList.map(item => {
              item.modifyTime = TimeFormat.getFormatTime(item.modifyTime)
            })
          }
          this.tData = data
        })
      }
    },
    mounted () {
      this.preInitTable()
    }
  }
</script>

<style scoped>
</style>